import React from 'react';
import { CheckCircle, Target, Eye, Award } from 'lucide-react';
import { equipoInfo } from '../mock';

const QuienesSomos = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="hero-section py-24">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl lg:text-6xl font-bold text-white heading-font mb-6">
            Quiénes Somos
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Somos una empresa líder en servicios eléctricos, construcción, mantención y servicios,
            comprometida con la excelencia y la satisfacción de nuestros clientes.
          </p>
        </div>
      </section>

      {/* Misión y Visión */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12">
            {/* Quienes somos */}
            <div className="bg-white rounded-2xl p-10 shadow-xl">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center mb-6">
                <Target className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-3xl font-bold heading-font mb-4">Quienes Somos</h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                {equipoInfo.somos}
              </p>
            </div>

            {/* Capacidades y redes de apoyo */}
            <div className="bg-white rounded-2xl p-10 shadow-xl">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-yellow-500 to-yellow-600 flex items-center justify-center mb-6">
                <Eye className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-3xl font-bold heading-font mb-4">Capacidades y Redes de Apoyo</h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                {equipoInfo.capacidades}
              </p>
            </div>
            
            {/* Nuestro enfoque */}
            <div className="bg-white rounded-2xl p-10 shadow-xl">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-yellow-500 to-yellow-600 flex items-center justify-center mb-6">
                <Eye className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-3xl font-bold heading-font mb-4">Nuestro Enfoque</h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                {equipoInfo.enfoque}
              </p>
            </div>
            
            {/* Innovación y Mejora Continua */}
            <div className="bg-white rounded-2xl p-10 shadow-xl">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center mb-6">
                <Target className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-3xl font-bold heading-font mb-4">Innovación y Mejora Continua</h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                {equipoInfo.innovacion}
              </p>
            </div>
            
            {/* Personas y Desarrollo Humano */}
            <div className="bg-white rounded-2xl p-10 shadow-xl">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center mb-6">
                <Target className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-3xl font-bold heading-font mb-4">Personas y Desarrollo Humano</h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                {equipoInfo.personas}
              </p>
            </div>
            
               {/* Crecimiento y Proyección */}
            <div className="bg-white rounded-2xl p-10 shadow-xl">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-yellow-500 to-yellow-600 flex items-center justify-center mb-6">
                <Eye className="w-8 h-8 text-white" />
              </div>
              <h2 className="text-3xl font-bold heading-font mb-4">Crecimiento y Proyección</h2>
              <p className="text-gray-700 text-lg leading-relaxed">
                {equipoInfo.crecimiento}
              </p>
            </div>
            
            
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-4">Nuestros Valores</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Los principios que guían nuestro trabajo diario
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {equipoInfo.valores.map((valor, index) => (
              <div
                key={index}
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow"
              >
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center mb-6">
                  <CheckCircle className="w-7 h-7 text-blue-600" />
                </div>
                <h3 className="text-2xl font-bold heading-font mb-3">{valor.nombre}</h3>
                <p className="text-gray-600">{valor.descripcion}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Por qué elegirnos */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-6">
                ¿Por qué elegir SACER?
              </h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-full bg-yellow-400 flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-6 h-6 text-blue-900" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Experiencia Comprobada</h3>
                    <p className="text-gray-600">
                      Brindamos servicios de alta calidad en el sector eléctrico, de construcción, de mantencion y de servicos.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-full bg-yellow-400 flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-6 h-6 text-blue-900" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Personal Certificado</h3>
                    <p className="text-gray-600">
                      Todos nuestros técnicos cuentan con certificaciones SEC y capacitación continua.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-full bg-yellow-400 flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-6 h-6 text-blue-900" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Garantía de Calidad</h3>
                    <p className="text-gray-600">
                      Todos nuestros trabajos incluyen garantía y certificación correspondiente.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 rounded-full bg-yellow-400 flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-6 h-6 text-blue-900" />
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Atención Personalizada</h3>
                    <p className="text-gray-600">
                      Cada proyecto es único y recibe nuestra completa dedicación y atención.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1621905251189-08b45d6a269e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2FsJTIwbWFpbnRlbmFuY2V8ZW58MHx8fHwxNzgxNTgwNDg2fDA&ixlib=rb-4.1.0&q=85"
                alt="Equipo SACER"
                className="rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-2xl flex items-center justify-center">
                <div className="text-center">
                  <Award className="w-12 h-12 text-blue-900 mx-auto mb-1" />
                  <p className="text-blue-900 font-bold text-sm">Certificados</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default QuienesSomos;